import React, { useState, useEffect } from 'react';
import axios from 'axios';
const GetAudioCall = (props) => {

    const [message, setMessage] = useState('');
    const [audioUrl, setAudioUrl] = useState(null);

    useEffect(() => {
        const asteriskQueueId = props.task.CMP_DETAILS.asteriskQueue;
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/asteriskQueues/${asteriskQueueId}`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            }
        };

        axios(options).then((response) => {
            const asteriskQueueName = response.data.name;

            const rut = String(props.task.clientId).replace(/-/g, '');
            const urlGetRecord = `${process.env.REACT_APP_URI_API_AUDIO}/getRecordFromCampaign?cedente=${asteriskQueueName}&cmp_id=${props.task.campaignId}&rut=${rut}&telefono=${props.task.phone}&download=no`;

            axios.get(urlGetRecord).then((checkResponse) => {
                if (checkResponse.data.message === 'Archivo NO Disponible') {
                    setMessage('Audio no disponible');
                } else if (checkResponse.data.message === 'Archivo Disponible') {
                    const urlDownloadRecord = urlGetRecord.replace('download=no', 'download=yes');

                    axios.get(urlDownloadRecord, { responseType: 'blob' }).then((audioResponse) => {
                        const blobUrl = URL.createObjectURL(audioResponse.data);
                        setAudioUrl(blobUrl);
                    }).catch((error) => {
                        console.log('Error:', error.message);
                    });
                }
            }).catch((error) => {
                console.log('Error:', error.message);
            });

        }).catch((error) => {
            console.log('Error:', error.message);
        });
    }, []);

    return (
        <div className="audioCall">
            {message && <p>{message}</p>}
            {audioUrl && (
                <audio controls src={audioUrl}>
                    Tu navegador no soporta el elemento de audio.
                </audio>
            )}
        </div>
    );

}

export default GetAudioCall;
